<template>
  <div class="page">
    <form class="page__content u-space" @submit.prevent="onSubmit">
      <div class="u-space">
        <label
          v-for="(player, colour) in players"
          :key="colour"
          class="input-group"
        >
          <strong :class="`player-name player-name--${colour}`">{{
            colour
          }}</strong>
          <input type="text" :value="player" @input="onInput($event, colour)" />
        </label>
      </div>
      <button type="submit" class="button">Start game</button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      players: {
        red: "",
        black: "",
        yellow: "",
        green: "",
        blue: ""
      }
    };
  },

  methods: {
    onInput(event, index) {
      this.players[index] = event.target.value;
    },

    onSubmit() {
      const fullPlayers = Object.keys(this.players)
        .map(x => ({ colour: x, name: this.players[x] }))
        .filter(x => !!x.name);

      if (fullPlayers.length >= 2) {
        this.$store.dispatch("startGame", fullPlayers);
      }
    }
  }
};
</script>
